<template>
  <template v-if="isLoading">
    <div class="wishlist-share-page__products-loader">
      <svg v-if="isDesktopScreen">
        <use xlink:href="#wishlist-product-grid-skeleton-desktop"></use>
      </svg>
      <svg v-else>
        <use xlink:href="#wishlist-product-grid-skeleton-mobile"></use>
      </svg>
    </div>
  </template>

  <template v-else>
    <div class="wishlist-share-page">
      <!-- Header section -->
      <div class="wishlist-share-page__header">
        <h3 class="wishlist-share-page__header-title">{{ listDetails.lname }}</h3>
      </div>

      <!-- User info section -->
      <div class="wishlist-share-page__share-info">
        <p>{{ listDetails?.userinfo?.fname }} ({{ listDetails?.userinfo?.em }}) has shared this list with you</p>
      </div>

      <!-- Product list section -->
      <div class="wishlist-share-page__product-container">
        <ProductCard
          v-for="product in listContent"
          :key="product.epi"
          type="TypeD"
          :product="product"
          @product-click="handleProductClick"
          @add-to-cart="handleAddToCart"
          :showWishlistIcon="false"
        />
      </div>

      <!-- Modal -->
      <template v-if="isDesktopScreen">
        <Modal
          v-if="isModalOpen"
          :onCloseModal="handleModalClose"
          :title="`Share ${listDetails.lname}`"
          customClass="wishlist-share-page"
        >
          <ShareList :onCancel="handleModalClose" :isDesktopScreen="isDesktopScreen" />
        </Modal>
      </template>

      <template v-else>
        <BottomDrawer v-if="isModalOpen" title="Share Wishlist" :onCloseModal="handleModalClose">
          <ShareList
            :onCancel="handleModalClose"
            :isDesktopScreen="isDesktopScreen"
            :selectedWishlistDetails="listDetails"
          />
        </BottomDrawer>
      </template>
    </div>
  </template>
</template>

<script setup>
  import { onMounted, ref, computed } from 'vue';
  import { fetchWishlistDetails } from './api';
  import { MEDIA_TYPES } from '../../utils/constants';
  import { useMediaType } from '../../utils/use-media-type';
  import ProductCard from '../global/product-card/index.vue';
  import Modal from '../global/modal.vue';
  import BottomDrawer from '../global/bottom-drawer.vue';
  import ShareList from './components/atoms/share-list.vue';

  const mediaType = useMediaType();

  const listDetails = ref({});
  const listContent = ref([]);
  const isModalOpen = ref(false);
  const isLoading = ref(true);

  const isDesktopScreen = computed(() =>
    [MEDIA_TYPES.TABLET_EXTRA_LARGE, MEDIA_TYPES.DESKTOP, MEDIA_TYPES.DESKTOP_LARGE].includes(mediaType.value)
  );

  onMounted(() => {
    getSharedList();
  });

  const getSharedList = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const lid = params.get('lid');

      if (lid) {
        const response = await fetchWishlistDetails(lid);
        if (response) {
          const { list, items } = response;
          listDetails.value = list;
          listContent.value = items;
          isLoading.value = false;
        }
      }
    } catch (error) {
      console.log('Error', error);
    }
  };

  const handleModalClose = () => {
    isModalOpen.value = false;
  };

  const handleAddToCart = async (product) => {
    window.openCart({ cartConfirmation: true });
    await window.Additem({ id: product.epi, quantity: 1 }, { visibility: false });
  };

  const handleProductClick = (product) => {
    const { cprops } = product;

    // Ensure product details and variant details exist
    const productHandle = cprops?.productDetails?.handle;
    const selectedColor = cprops?.variantDetails?.Color || '';

    window.location.href = `/products/${productHandle}/?color=${selectedColor}`;
  };
</script>
